import React from "react";
import { T } from "../theme";
import { Badge, Card, fmt, SectionTitle, TapeIcon } from "../ui";

export default function HomeScreen({ displayName, tapes, wishlist, onViewCollection, onAddTape }) {
  const totalValue = tapes.reduce((s, t) => s + Number(t.estimatedValue || 0), 0);
  const recent = tapes.slice(0, 3);

  return (
    <div>
      <Card style={{ background: `linear-gradient(135deg,${T.surface},${T.card})` }}>
        <div style={{ fontSize: 13, color: T.muted }}>Welcome back{displayName ? `, ${displayName}` : ""}</div>
      </Card>

      <SectionTitle>Your Collection</SectionTitle>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 12 }}>
        <div style={{ background: T.statBg, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 12px" }}>
          <div style={{ fontSize: 9, color: T.muted, letterSpacing: "0.15em", textTransform: "uppercase" }}>Total Tapes</div>
          <div style={{ fontSize: 18, fontWeight: "bold", color: T.accent, marginTop: 3 }}>{tapes.length}</div>
        </div>
        <div style={{ background: T.statBg, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 12px" }}>
          <div style={{ fontSize: 9, color: T.muted, letterSpacing: "0.15em", textTransform: "uppercase" }}>Est. Value</div>
          <div style={{ fontSize: 18, fontWeight: "bold", color: T.accent, marginTop: 3 }}>{fmt(totalValue)}</div>
        </div>
        <div style={{ background: T.statBg, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 12px" }}>
          <div style={{ fontSize: 9, color: T.muted, letterSpacing: "0.15em", textTransform: "uppercase" }}>Wishlist</div>
          <div style={{ fontSize: 18, fontWeight: "bold", color: T.accent, marginTop: 3 }}>{wishlist.length}</div>
        </div>
        <div style={{ background: T.statBg, border: `1px solid ${T.border}`, borderRadius: 8, padding: "10px 12px" }}>
          <div style={{ fontSize: 9, color: T.muted, letterSpacing: "0.15em", textTransform: "uppercase" }}>Recent Adds</div>
          <div style={{ fontSize: 18, fontWeight: "bold", color: T.accent, marginTop: 3 }}>{recent.length}</div>
        </div>
      </div>
      <div style={{ fontSize: 9, color: T.muted, marginBottom: 12 }}>Values are collector-entered estimates, not professional appraisals.</div>

      <button onClick={onAddTape} style={{ width: "100%", background: T.btnBg, border: "none", color: "#fff", padding: 12, borderRadius: 8, fontSize: 12, fontWeight: "bold", letterSpacing: "0.1em", cursor: "pointer", fontFamily: T.font, marginBottom: 16 }}>
        + Add a Tape
      </button>

      <SectionTitle>Recently Added</SectionTitle>
      {recent.length === 0 && (
        <Card style={{ textAlign: "center", padding: 24 }}>
          <div style={{ fontSize: 13, color: T.muted, marginBottom: 10 }}>Your vault is empty.</div>
          <button onClick={onAddTape} style={{ background: "none", border: `1px solid ${T.border}`, color: T.accent, padding: "8px 16px", borderRadius: 6, cursor: "pointer", fontFamily: T.font, fontSize: 12 }}>Add your first tape</button>
        </Card>
      )}
      {recent.map((t) => (
        <div key={t.id} onClick={onViewCollection} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: `1px solid ${T.border}`, cursor: "pointer" }}>
          <TapeIcon size={32} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, color: T.text, fontWeight: "bold" }}>{t.albumTitle}</div>
            <div style={{ fontSize: 11, color: T.muted }}>{t.artist}</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 13, color: T.value, fontWeight: "bold" }}>{fmt(t.estimatedValue)}</div>
            {t.condition && <Badge condition={t.condition} />}
          </div>
        </div>
      ))}
    </div>
  );
}
